<template>
    <v-container pa-0 ma-0 fluid>
        <v-row no-gutters>
            <v-col cols="2">
                <v-btn
                    color="primary"
                    outlined
                    small
                    class="btn_back"
                    v-on:click="closeTimeSeriesViewer"
                    >back to model
                </v-btn>
            </v-col>
            <v-col cols="4">
                <span class="title">{{title}}</span>
            </v-col>
            <v-col cols="6">
                <assetsFilter v-if="isRegionGrouped()"
                    title="Select Series" 
                    buttonName="Add / Remove Series" 
                    v-bind:assets="assetFilter"
                    v-bind:initialSelect="selected"
                    v-on:updateChartSeries="updateChartSeries">
                </assetsFilter>                
                <assetsFilterIRS v-if="isIrsGrouped()"
                    title="Select Series" 
                    buttonName="Add / Remove Series" 
                    v-bind:assets="assetFilter"
                    v-bind:initialSelect="selected"
                    v-on:updateChartSeries="updateChartSeries">
                </assetsFilterIRS>               
                <assetsFilterCredit v-if="isCreditGrouped()"
                    title="Select Series" 
                    buttonName="Add / Remove Series" 
                    v-bind:assets="assetFilter"
                    v-bind:initialSelect="selected"
                    v-on:updateChartSeries="updateChartSeries">
                </assetsFilterCredit>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12">
                <highcharts style="height: 500px" class="stock" :constructor-type="'stockChart'" :options="chartOptionsStock"></highcharts>
            </v-col>
        </v-row>
        <v-dialog v-model="chartIsLoading" fullscreen full-width>
            <v-container fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
              <v-layout justify-center align-center>
                <v-progress-circular
                    :size="50"
                    color="primary"
                    class="chartIsLoading"
                    indeterminate
                    v-show="chartIsLoading"
                ></v-progress-circular>
              </v-layout>
            </v-container>
        </v-dialog>
    </v-container>    
</template>
<script>

import axios from 'axios'
import systematicEconomics from '@/api/systematicEconomics'
import assetsFilter from '@/components/AssetsFilter.vue'
import assetsFilterIRS from '@/components/AssetsFilterIRS.vue'
import assetsFilterCredit from '@/components/AssetsFilterCredit.vue'
export default {
    name: 'TimeSeriesStock',
    props: {
        url:{
            type: String,
            required: true
        },
        title:{
            type: String,
            required: true
        },
        grouped_by:{
            type: String,
            required: true
        }
    },
    components: {
        assetsFilter,
        assetsFilterIRS,
        assetsFilterCredit
    },
    data(){
      return {
        chartIsLoading: true,
        stock:[],
        timeSeries:[],
        assets: [],
        assetFilter: [],
        selected: [],        
        chartOptionsStock: {
            credits: {
                enabled: false
            },
            chart: {
            zoomType: 'x',
            renderTo: 'chart'
            },
            legend: {
                enabled: true,
                itemStyle: {
                    fontSize: '9px',
                    fontFamily: 'Verdana, sans-serif'
                },
                itemHoverStyle: {
                  color: '#ff0000'
                }
            },
            title :{
                text: ''
            },
            tooltip: {
                valueDecimals: 2
            },
            xAxis: {
                type: 'datetime'
            },
            yAxis: {                
                gridLineDashStyle:'Dot',
                gridLineColor:'blue',
                gridLineWidth:1,
                tickInterval: 0.5,
                /*max: 2,
                min: -2,*/
            },
            series: []
        },
      }
    },
    created(){
        var request={
            path:this.url
        }
        this.getJson(request)
    },
    methods:{
        isRegionGrouped(){
            return (this.grouped_by=="region")
        },
        isIrsGrouped(){
            return (this.grouped_by=="irs")
        },
        isCreditGrouped(){
            return (this.grouped_by=="credit")
        },
        getJson(request) {    
            const me = this 
            return new Promise((resolve, reject) => {
                systematicEconomics.getJson(request).then(
                    data => {
                        var json = JSON.parse(atob(data))
                        me.timeSeries =_.cloneDeep(json.assetStocks);
                        
                        _.forEach(me.timeSeries, function(item) {
                            var asset={
                                name: item.name,
                                groupname: item.groupname
                            }
                            if(item.name != item.groupname){
                                me.assetFilter.push(asset)
                            }else{
                                me.selected.push(item.name);
                            }
                        });
                        _.forEach(me.timeSeries, function(item) {
                            me.assets.push(item.name);
                        });
                        me.updateChartSeries(me.selected)                
                        me.chartIsLoading = false;
                    }
                )
            })
        },
        updateChartSeries(selected){
            var me = this;
            var newStockSeries = _.cloneDeep(me.timeSeries);  
            var diff = _.difference(me.assets,selected);
            _.forEach(diff, function(item) {
                _.remove(newStockSeries, function(o){ return o.name == item;});
            });
            me.chartOptionsStock.series = newStockSeries;
        },
        closeTimeSeriesViewer(){
            this.$emit('close-timeSeriesViewer','true');
        },
    }
}
</script>
<style scoped>
    .title{
        font-size: 22px !important;
        font-weight: 400;      
    }
</style>